// extracted by mini-css-extract-plugin
var _1 = "_customerManagementCustomerDetailsForm-module__button-container";
var _2 = "_customerManagementCustomerDetailsForm-module__button-subcontainer";
var _3 = "_customerManagementCustomerDetailsForm-module__container";
var _4 = "_customerManagementCustomerDetailsForm-module__form-container";
var _5 = "_customerManagementCustomerDetailsForm-module__input-label";
var _6 = "_customerManagementCustomerDetailsForm-module__joint-account-details-container";
var _7 = "_customerManagementCustomerDetailsForm-module__link";
var _8 = "_customerManagementCustomerDetailsForm-module__paper-balance-container";
var _9 = "_customerManagementCustomerDetailsForm-module__span-2";
export { _1 as "button-container", _2 as "button-subcontainer", _3 as "container", _4 as "form-container", _5 as "input-label", _6 as "joint-account-details-container", _7 as "link", _8 as "paper-balance-container", _9 as "span-2" }
